module.exports = __webpack_public_path__ + "img/goods_02.c0e60206.jpg";